import React from 'react';
import { Button, Icon, useDisclosure } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import useCustomRiskObjectsFromPolicies from '../../../../../../../advisory-report/src/features/creation-flow/components/insurance-policies/hooks/useCustomRiskObjectsFromPolicies';
import PartyAddInsurancePolicyModal from './PartyAddInsurancePolicyModal';
import { InsurancePolicy } from '../../../../../../../advisory-report/src/types/AdvisoryReport';
import { PartyType } from '../../../../../../../../types/SMT';

interface Props {
  partyId: string;
  insurancePolicies: InsurancePolicy[];
  partyDisplayName?: string;
  partyType?: PartyType;
  type: 'CURRENT-INSURANCE' | 'OFFER';
}

const PartyAddInsurancePolicyButton: React.FC<Props> = ({
  partyId,
  insurancePolicies,
  partyDisplayName,
  partyType,
  type,
}) => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { t } = useTranslation();
  const _customRiskObjects = useCustomRiskObjectsFromPolicies(
    {
      current_insurances: insurancePolicies,
      offers: [],
    },
    partyId,
  );

  const customRiskObjects = partyDisplayName
    ? [
        ..._customRiskObjects,
        {
          label: partyDisplayName,
          value: partyDisplayName,
        },
      ]
    : _customRiskObjects;

  return (
    <>
      {/* MODAL */}
      <PartyAddInsurancePolicyModal
        type={type}
        mode="ADD"
        isOpen={isOpen}
        onClose={onClose}
        customRiskObjects={customRiskObjects}
        partyId={partyId}
        partyType={partyType}
      />
      <Button
        onClick={onOpen}
        leftIcon={<Icon name="GeneralActionsAdd" />}
        size="sm"
      >
        {type === 'CURRENT-INSURANCE'
          ? t('PARTIES_PARTY-DETAIL_CURRENT-INSURANCES_ADD')
          : t('ADVISORY-REPORTS_CREATION-FLOW_OFFER_MODAL_ADD_TITLE')}
      </Button>
    </>
  );
};

export default PartyAddInsurancePolicyButton;
